import React, { PropTypes } from 'react';
import Provider from './Provider';

const headerStyle = {
    cursor: 'default',
    fontSize: '13px'
};

const ProviderList = ({ filter, providers, providerSelect, header }) => {
    const listHeader = header && !filter ? (
        <li className="watchProvider__list-header">
            <a style={headerStyle}>{header}</a>
        </li>
    ) : null;
    return (
        <ul className="watchProvider__list-items">
            {listHeader}
            {providers
                .filter((provider) => (provider.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0))
                .map((provider) => (
                    <Provider
                        key={provider.id}
                        provider={provider}
                        providerSelect={providerSelect}
                    />
                ))
            }
        </ul>
    );
};

ProviderList.propTypes = {
    filter: PropTypes.string,
    providerSelect: PropTypes.func,
    providers: PropTypes.array,
    header: PropTypes.string
};

ProviderList.defaultProps = {
    providers: []
};

export default ProviderList;



// WEBPACK FOOTER //
// ./app/common/chooseProvider/ProviderList.js